<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="学期">
              <el-select v-model="filterSemesterId" clearable placeholder="全部学期" class="toolbar-field-w-lg"
                :disabled="!schoolId" @change="onSemesterFilterChange">
                <el-option v-for="s in semesterList" :key="semesterId(s)" :label="semesterName(s)"
                  :value="semesterId(s)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索">
              <el-input v-model="listKeyword" clearable placeholder="标题" class="toolbar-field-w-md"
                :disabled="!schoolId"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" :disabled="!schoolId" @click="searchList">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button type="success" size="small" icon="el-icon-plus" :disabled="!schoolId" @click="openCreateDialog">新建问卷</el-button>
            <el-button size="small" :disabled="!schoolId" @click="goQuestionBank">默认题库</el-button>
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="toolbarBtnType(item)"
              :icon="toolbarBtnIcon(item)"
              :loading="!!item.loading"
              @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>

      <div class="hv-table-wrap">
        <el-table :data="questionnaireList" v-loading="listLoading" stripe size="small" height="100%">
        <el-table-column prop="Title" label="标题" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="SemesterName" label="学期" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="默认" width="72" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsDefault" type="success" size="mini">默认</el-tag>
            <span v-else class="hv-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="QuestionCount" label="题数" width="70" align="center"></el-table-column>
        <el-table-column label="截止时间" width="155" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.Deadline || '—' }}</template>
        </el-table-column>
        <el-table-column label="修改时间" width="155">
          <template slot-scope="scope">{{ formatTime(scope.row.ModifyTime || scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" size="small" class="table-op-link" @click="openDetailDialog(scope.row)">详情</el-button>
              <el-button v-if="!scope.row.IsDefault" type="text" size="small" class="table-op-link" @click="handleSetDefault(scope.row)">设为默认</el-button>
              <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <el-col v-if="schoolId" :span="24" class="toolbar">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="listPage" :page-sizes="[10, 20, 50]"
          :page-size="listPageSize" :total="listTotal" style="float: right" @size-change="handleListSizeChange"
          @current-change="handleListPageChange"></el-pagination>
      </el-col>
      <div v-if="!schoolId" class="hv-empty">请在左侧选择学校</div>

      <!-- 问卷详情弹窗 -->
      <el-dialog :visible.sync="detailDialogVisible" width="960px" top="4vh" custom-class="hv-detail-dialog"
        append-to-body :close-on-click-modal="false" @closed="onDetailDialogClosed">
        <div slot="title" class="hv-detail-dialog__title">
          <span class="hv-detail-dialog__title-text">
            {{ questionnaire && questionnaire.Title ? questionnaire.Title : '问卷详情' }}
          </span>
          <el-tag v-if="questionnaire && questionnaire.IsDefault" type="success" size="mini" effect="plain">默认问卷</el-tag>
          <span v-if="questionnaire && questionnaire.SemesterName" class="hv-detail-dialog__meta">{{ questionnaire.SemesterName }}</span>
          <span class="hv-detail-dialog__meta">{{ detailQuestionCount }} 题</span>
        </div>
        <div class="hv-detail-body" v-loading="detailLoading">
          <div class="hv-detail-section">
            <div class="hv-detail-section__label">基本信息</div>
            <el-form label-width="72px" size="small" class="hv-detail-form hv-detail-form--meta">
              <div class="hv-detail-meta-row">
                <el-form-item label="标题" class="hv-detail-form-item--title">
                  <el-input v-model="draftTitle" placeholder="请输入问卷标题" maxlength="100"
                    show-word-limit class="hv-detail-title-input"></el-input>
                </el-form-item>
                <el-form-item label="学期" class="hv-detail-form-item--semester">
                  <el-input :value="questionnaire && questionnaire.SemesterName" disabled
                    class="hv-detail-semester-input"></el-input>
                </el-form-item>
                <el-form-item label="截止时间" class="hv-detail-form-item--deadline">
                  <el-date-picker v-model="draftDeadline" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="可选" class="hv-detail-deadline-picker"></el-date-picker>
                </el-form-item>
              </div>
            </el-form>
          </div>

          <div class="hv-detail-section hv-detail-section--questions">
            <div class="hv-detail-section__head">
              <div class="hv-detail-section__head-text">
                <div class="hv-detail-section__label">题目列表</div>
                <p class="hv-detail-section__desc">
                  共 {{ detailQuestionCount }} 题；可单独新增/编辑题目，导入 Excel 或「初始化10题」将全量覆盖
                </p>
              </div>
              <div class="hv-detail-section__tools">
                <el-button size="small" type="primary" plain icon="el-icon-plus"
                  @click="openQuestionEditDialog()">新增题目</el-button>
                <el-button size="small" plain icon="el-icon-refresh" @click="handleInitDefault">初始化10题</el-button>
                <el-button size="small" plain icon="el-icon-upload2" @click="openImportDialog">导入题目</el-button>
              </div>
            </div>

            <el-table v-if="detailQuestionCount" :data="questionnaire.Questions" stripe size="small"
              max-height="360" class="hv-detail-table">
              <el-table-column prop="SortNo" label="题号" width="64" align="center"></el-table-column>
              <el-table-column prop="SectionTitle" label="分组" width="128" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span class="hv-detail-section-tag">{{ scope.row.SectionTitle || '—' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Title" label="题干" min-width="200" show-overflow-tooltip></el-table-column>
              <el-table-column label="选项" min-width="220">
                <template slot-scope="scope">
                  <span v-for="(opt, idx) in questionOptions(scope.row)" :key="opt.Id || opt.id || idx"
                    class="hv-detail-opt-chip">
                    <span class="hv-detail-opt-chip__key">{{ opt.OptionKey || opt.optionKey }}</span>
                    {{ opt.OptionText || opt.optionText }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="必填" width="72" align="center">
                <template slot-scope="scope">
                  <span class="hv-detail-required" :class="{ 'is-yes': scope.row.IsRequired }">
                    {{ scope.row.IsRequired ? '必填' : '选填' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="table-op-pair">
                    <el-button type="text" size="small" class="table-op-link" @click="openQuestionEditDialog(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" class="table-op-link table-op-link--danger" :loading="deletingQuestionId === questionRowId(scope.row)"
                      @click="handleDeleteQuestion(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="hv-detail-empty">
              <i class="el-icon-document-remove"></i>
              <p>暂无题目</p>
              <span>可点击「新增题目」「初始化10题」或「导入题目」添加内容</span>
              <el-button type="primary" plain size="small" icon="el-icon-plus" class="hv-detail-empty__btn"
                @click="openQuestionEditDialog()">新增题目</el-button>
            </div>
          </div>
        </div>
        <div slot="footer" class="hv-detail-dialog__footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
          <el-button v-if="questionnaire && !questionnaire.IsDefault" plain class="hv-detail-btn-plain"
            @click="handleSetDefault(questionnaire)">设为默认</el-button>
          <el-button type="primary" class="hv-detail-btn-primary" :loading="saving" @click="handleSaveMeta">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="questionEditForm.id ? '编辑题目' : '新增题目'" :visible.sync="questionEditDialogVisible"
        width="640px" append-to-body custom-class="hv-edit-dialog" @closed="resetQuestionEditForm">
        <el-form label-width="88px" size="small" class="hv-edit-form">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="题号">
                <el-input-number v-model="questionEditForm.sortNo" :min="1" :max="999" controls-position="right"
                  style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="分组">
                <el-input v-model="questionEditForm.sectionTitle" placeholder="如：一、居家学习"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="题干" required>
            <el-input v-model="questionEditForm.title" type="textarea" :rows="2" placeholder="请输入题干"></el-input>
          </el-form-item>
          <el-form-item label="选项" required class="hv-options-item">
            <div class="hv-options-panel">
              <div v-for="(opt, idx) in questionEditForm.optionTexts" :key="idx" class="hv-opt-row">
                <span class="hv-opt-badge">{{ questionOptionKeys[idx] }}</span>
                <el-input v-model="questionEditForm.optionTexts[idx]" placeholder="请输入选项内容"
                  class="hv-opt-input"></el-input>
                <el-button v-if="questionEditForm.optionTexts.length > 2" type="text" icon="el-icon-delete"
                  class="hv-opt-del" title="删除该选项" @click="removeQuestionOption(idx)"></el-button>
                <span v-else class="hv-opt-del-placeholder"></span>
              </div>
              <el-button v-if="questionEditForm.optionTexts.length < 6" type="text" icon="el-icon-plus"
                class="hv-opt-add" @click="addQuestionOption">添加选项</el-button>
            </div>
          </el-form-item>
          <el-form-item label="必填">
            <el-switch v-model="questionEditForm.isRequired"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="hv-edit-footer">
          <el-button @click="questionEditDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="questionSaving" @click="submitQuestionEdit">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="createDialogVisible" width="760px" custom-class="hv-create-dialog"
        append-to-body :close-on-click-modal="false">
        <div slot="title" class="hv-create-dialog__title-main">新建问卷</div>
        <div class="hv-create-body">
          <p class="hv-create-intro">填写学期与标题，按需从默认题库勾选题目</p>
          <div class="hv-create-section hv-create-section--basic">
            <div class="hv-create-section__label">基本信息</div>
            <el-form ref="createFormRef" :model="createForm" :rules="createFormRules" label-width="72px" size="small"
              class="hv-create-form" label-position="right">
              <el-form-item label="学期" prop="semesterId" required>
                <el-select v-model="createForm.semesterId" placeholder="请选择学期" style="width: 100%">
                  <el-option v-for="s in semesterList" :key="semesterId(s)" :label="semesterName(s)"
                    :value="semesterId(s)"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标题" prop="title" required>
                <el-input v-model="createForm.title" placeholder="如：中职班主任家访调研" maxlength="100"
                  show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="hv-create-section hv-create-section--bank">
            <div class="hv-create-section__head">
              <div class="hv-create-section__head-text">
                <div class="hv-create-section__label">题目来源</div>
                <p class="hv-create-section__desc">开启后从默认题库勾选；关闭则创建空白问卷，稍后在详情中导入或初始化</p>
              </div>
              <el-switch v-model="createForm.fromBank" active-color="#2563EB" active-text="从题库选题"
                inactive-text="空白问卷"></el-switch>
            </div>

            <el-alert v-if="!createForm.fromBank" class="hv-create-alert" type="info" :closable="false" show-icon
              title="将创建无题目的空白问卷，可在详情页导入 Excel 或使用「初始化10题」。"></el-alert>

            <div v-else class="hv-bank-picker">
              <div class="hv-bank-picker__toolbar">
                <div class="hv-bank-picker__stats">
                  <span class="hv-stat-chip">共 {{ bankQuestions.length }} 题</span>
                  <span class="hv-stat-chip hv-stat-chip--active">已选 {{ selectedBankQuestionIds.length }} 题</span>
                </div>
                <el-button type="text" class="hv-bank-manage-btn" icon="el-icon-setting"
                  @click="goQuestionBank">管理默认题库</el-button>
              </div>
              <el-table ref="bankTable" :data="bankQuestions" :row-key="bankTableRowKey" size="small"
                max-height="300" stripe class="hv-bank-table hv-bank-table--clickable"
                @selection-change="onBankSelectionChange" @row-click="onBankTableRowClick">
                <el-table-column type="selection" width="48" align="center"></el-table-column>
                <el-table-column prop="SortNo" label="题号" width="56" align="center"></el-table-column>
                <el-table-column prop="SectionTitle" label="分组" width="112" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Title" label="题干" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column label="默认" width="68" align="center">
                  <template slot-scope="scope">
                    <el-tag v-if="isBankDefault(scope.row)" type="success" size="mini" effect="plain">默认</el-tag>
                    <span v-else class="hv-muted">—</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div slot="footer" class="hv-create-footer">
          <el-button @click="createDialogVisible = false">取消</el-button>
          <el-button type="primary" class="hv-create-submit" :loading="creating" @click="handleCreate">创建问卷</el-button>
        </div>
      </el-dialog>

      <el-dialog title="导入题目" :visible.sync="importFormDialogVisible" width="520px" @closed="resetImportForm">
        <div class="hv-import-panel">
          <div class="hv-import-step">
            <span class="hv-step-no">1</span>
            <div class="hv-step-body">
              <div class="hv-step-title">下载 Excel 模板</div>
              <div class="hv-step-desc">按模板填写题目与选项后上传，将全量覆盖当前问卷题目。</div>
              <el-button type="primary" plain icon="el-icon-download" size="small" @click="handleDownloadTemplate">
                下载导入模板
              </el-button>
            </div>
          </div>
          <div class="hv-import-step">
            <span class="hv-step-no">2</span>
            <div class="hv-step-body">
              <div class="hv-step-title">上传 Excel 文件</div>
              <el-upload class="hv-upload-block" drag action="#" :auto-upload="false" :limit="1"
                accept=".xlsx,.xls" :file-list="importFileList" :on-change="onImportFileChange"
                :on-remove="onImportFileRemove">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">仅支持 .xlsx / .xls</div>
              </el-upload>
            </div>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="importFormDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="importing" :disabled="!importFileRaw" @click="submitImport">
            开始导入
          </el-button>
        </div>
      </el-dialog>

      <el-dialog title="导入结果" :visible.sync="importResultDialogVisible" width="760px">
        <div class="hv-result-summary">
          <el-tag :type="importErrors.length ? 'warning' : 'success'" size="small">
            {{ importResultMsg }}
          </el-tag>
          <span v-if="importDetailQuestions.length" class="hv-result-count">
            共 {{ importDetailQuestions.length }} 题
          </span>
        </div>
        <div v-if="importErrors.length" class="hv-result-block">
          <div class="hv-result-label">错误明细</div>
          <el-table :data="importErrors" size="mini" max-height="160">
            <el-table-column prop="rowNumber" label="行号" width="80"></el-table-column>
            <el-table-column prop="message" label="错误说明" min-width="200"></el-table-column>
          </el-table>
        </div>
        <div v-if="importDetailQuestions.length" class="hv-result-block">
          <div class="hv-result-label">题目明细</div>
          <el-table :data="importDetailQuestions" size="mini" max-height="320">
            <el-table-column prop="SortNo" label="题号" width="55" align="center"></el-table-column>
            <el-table-column prop="SectionTitle" label="分组" width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="Title" label="题干" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="选项" min-width="200">
              <template slot-scope="scope">
                <span v-for="(opt, idx) in questionOptions(scope.row)" :key="opt.Id || opt.id || idx" class="hv-opt-chip">
                  {{ opt.OptionKey || opt.optionKey }}.{{ opt.OptionText || opt.optionText }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="必填" width="55" align="center">
              <template slot-scope="scope">
                {{ scope.row.IsRequired ? '是' : '否' }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="importResultDialogVisible = false">知道了</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import toolbarFilterBarMixin from "@/mixins/toolbarFilterBarMixin";
import {
  getHomeVisitQuestionnaireList,
  getHomeVisitQuestionnaireDetail,
  saveHomeVisitQuestionnaire,
  initHomeVisitDefaultQuestions,
  getHomeVisitQuestionBankAll,
  createHomeVisitQuestionnaireFromBank,
  setHomeVisitQuestionnaireDefault,
  deleteHomeVisitQuestionnaire,
  deleteHomeVisitQuestionnaireQuestion,
  saveHomeVisitQuestionnaireQuestion,
  importHomeVisitQuestions,
  downloadHomeVisitImportTemplate,
  downloadBlobExcel,
  loadHomeVisitSemesterList,
  onHomeVisitSchoolChange,
  resolveHomeVisitSchoolIdFromTreeNode,
  homeVisitSemesterId,
  homeVisitSemesterName,
  homeVisitQuestionOptions,
  isHomeVisitBankDefault
} from "@/api/homeVisit";

export default {
  mixins: [toolbarFilterBarMixin],
  components: { DepartmentPane },
  data() {
    return {
      DepartmentId: 0,
      schoolId: 0,
      semesterList: [],
      filterSemesterId: null,
      listKeyword: "",
      listPage: 1,
      listPageSize: 10,
      questionnaireList: [],
      listTotal: 0,
      listLoading: false,
      questionnaire: null,
      draftTitle: "",
      draftDeadline: null,
      detailDialogVisible: false,
      currentDetailId: 0,
      detailLoading: false,
      deletingQuestionId: 0,
      questionEditDialogVisible: false,
      questionSaving: false,
      questionOptionKeys: ["A", "B", "C", "D", "E", "F"],
      questionEditForm: {
        id: null,
        sortNo: 1,
        sectionTitle: "",
        title: "",
        optionTexts: ["", "", "", ""],
        isRequired: true
      },
      saving: false,
      importing: false,
      creating: false,
      createDialogVisible: false,
      createForm: { semesterId: null, title: "", fromBank: true },
      createFormRules: {
        semesterId: [{ required: true, message: "请选择学期", trigger: "change" }],
        title: [
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error("请输入问卷标题"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      bankQuestions: [],
      selectedBankQuestionIds: [],
      importFormDialogVisible: false,
      importResultDialogVisible: false,
      importFileList: [],
      importFileRaw: null,
      importResultMsg: "",
      importErrors: [],
      importDetailQuestions: [],
      actionButtonList: [],
      semesterLoadTask: null,
      semesterLoadSchoolId: 0,
      listLoadTask: null,
      listLoadKey: "",
      detailLoadTask: null,
      detailLoadId: 0
    };
  },
  computed: {
    detailId() {
      return this.currentDetailId || 0;
    },
    detailQuestionCount() {
      const questions = this.questionnaire && this.questionnaire.Questions;
      return questions ? questions.length : 0;
    }
  },
  watch: {
    "createForm.fromBank"(val) {
      if (val) {
        this.$nextTick(() => this.applyBankTableSelection());
      } else {
        this.selectedBankQuestionIds = [];
      }
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.actionButtonList = (buttonList || []).filter((b) => b.Func !== "handleQuery");
    this.syncSchoolIdFromStore();
    const routeDetailId = this.$route.query.id ? Number(this.$route.query.id) : 0;
    if (routeDetailId) {
      this.$router.replace({ path: this.$route.path, query: {} });
      if (this.schoolId) {
        this.loadSemesterOptions(this.schoolId).then(() => {
          this.loadList();
          this.openDetailDialog(routeDetailId);
        });
      } else {
        this.openDetailDialog(routeDetailId);
      }
      return;
    }
    if (this.schoolId) {
      this.loadSemesterOptions(this.schoolId).then(() => this.loadList());
    }
  },
  activated() {
    if (this.schoolId && !this.questionnaireList.length && !this.detailDialogVisible) {
      this.loadList();
    }
  },
  methods: {
    semesterId: homeVisitSemesterId,
    semesterName: homeVisitSemesterName,
    questionOptions: homeVisitQuestionOptions,
    isBankDefault: isHomeVisitBankDefault,

    questionRowId(row) {
      return row ? Number(row.Id || row.id || 0) : 0;
    },

    formatTime(val) {
      if (!val) return "—";
      return String(val).replace("T", " ").substring(0, 16);
    },

    handleListPageChange(val) {
      this.listPage = val;
      this.loadList();
    },

    handleListSizeChange(val) {
      this.listPageSize = val;
      this.listPage = 1;
      this.loadList();
    },

    searchList() {
      this.syncSchoolIdFromStore();
      this.listPage = 1;
      this.loadList();
    },

    onSemesterFilterChange() {
      this.listPage = 1;
      this.loadList();
    },

    async treeNodeClick(data, node) {
      const nextSchoolId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
      const schoolChanged = nextSchoolId !== this.schoolId;
      if (schoolChanged) {
        if (this.detailDialogVisible) {
          this.DepartmentId = data.value;
          this.schoolId = nextSchoolId;
          await this.loadSemesterOptions(this.schoolId || this.DepartmentId);
        } else {
          onHomeVisitSchoolChange(this, data.value);
          this.schoolId = nextSchoolId;
          this.listPage = 1;
          await this.loadSemesterOptions(this.schoolId || this.DepartmentId);
        }
      } else {
        this.DepartmentId = data.value;
      }
      if (this.detailDialogVisible) {
        await this.loadDetail();
      } else {
        await this.loadList();
      }
    },

    syncSchoolIdFromStore() {
      const activeSchoolId = Number(this.$store.state.activeSchoolId || 0);
      if (!this.schoolId && activeSchoolId > 0) {
        this.schoolId = activeSchoolId;
        this.DepartmentId = activeSchoolId;
      }
    },

    loadSemesterOptions(schoolId) {
      const targetSchoolId = Number(schoolId || 0);
      if (!targetSchoolId) return Promise.resolve();
      if (this.semesterLoadTask && this.semesterLoadSchoolId === targetSchoolId) {
        return this.semesterLoadTask;
      }
      const task = Promise.resolve(loadHomeVisitSemesterList(this, targetSchoolId));
      this.semesterLoadSchoolId = targetSchoolId;
      this.semesterLoadTask = task;
      return task.finally(() => {
        if (this.semesterLoadTask === task) {
          this.semesterLoadTask = null;
          this.semesterLoadSchoolId = 0;
        }
      });
    },

    parseQuestionnairePage(response) {
      if (!response) return { rows: [], total: 0 };
      const rows = response.data || response.Data || [];
      const total = response.dataCount != null
        ? response.dataCount
        : (response.DataCount != null ? response.DataCount : 0);
      return { rows, total };
    },

    async loadList() {
      this.syncSchoolIdFromStore();
      if (!this.schoolId) {
        this.questionnaireList = [];
        this.listTotal = 0;
        return;
      }
      if (!this.semesterList.length) {
        await this.loadSemesterOptions(this.schoolId);
      }
      const params = {
        schoolDepartmentId: this.schoolId,
        semesterId: this.filterSemesterId || 0,
        keyword: (this.listKeyword || "").trim() || undefined,
        page: this.listPage,
        pageSize: this.listPageSize
      };
      const requestKey = JSON.stringify(params);
      if (this.listLoadTask && this.listLoadKey === requestKey) return this.listLoadTask;

      this.listLoading = true;
      const task = (async () => {
        const res = await getHomeVisitQuestionnaireList(params);
        const d = res.data;
        if (d.success && d.response) {
          const page = this.parseQuestionnairePage(d.response);
          this.questionnaireList = page.rows;
          this.listTotal = page.total;
        } else {
          this.questionnaireList = [];
          this.listTotal = 0;
          this.$message.error(d.msg || "加载失败");
        }
      })();
      this.listLoadKey = requestKey;
      this.listLoadTask = task;
      try {
        return await task;
      } finally {
        if (this.listLoadTask === task) {
          this.listLoading = false;
          this.listLoadTask = null;
          this.listLoadKey = "";
        }
      }
    },

    async loadDetail() {
      if (!this.currentDetailId) return;
      const detailId = Number(this.currentDetailId);
      if (this.detailLoadTask && this.detailLoadId === detailId) return this.detailLoadTask;

      this.detailLoading = true;
      const task = (async () => {
        const res = await getHomeVisitQuestionnaireDetail(detailId);
        const d = res.data;
        if (detailId !== Number(this.currentDetailId)) return;
        if (d.success && d.response) {
          this.questionnaire = d.response;
          const schoolDeptId = d.response.SchoolDepartmentId || d.response.schoolDepartmentId;
          if (schoolDeptId) {
            this.schoolId = Number(schoolDeptId);
            this.DepartmentId = this.schoolId;
          }
          this.draftTitle = this.questionnaire.Title || "";
          this.draftDeadline = this.questionnaire.Deadline || null;
        } else {
          this.$message.error(d.msg || "加载失败");
        }
      })();
      this.detailLoadId = detailId;
      this.detailLoadTask = task;
      try {
        return await task;
      } finally {
        if (this.detailLoadTask === task) {
          this.detailLoading = false;
          this.detailLoadTask = null;
          this.detailLoadId = 0;
        }
      }
    },

    async openDetailDialog(rowOrId) {
      const id = rowOrId && typeof rowOrId === "object"
        ? Number(rowOrId.Id || rowOrId.id || 0)
        : Number(rowOrId || 0);
      if (!id) return;
      this.currentDetailId = id;
      this.detailDialogVisible = true;
      await this.loadDetail();
    },

    onDetailDialogClosed() {
      this.currentDetailId = 0;
      this.questionnaire = null;
      this.draftTitle = "";
      this.draftDeadline = null;
      this.loadList();
    },

    async openCreateDialog() {
      this.createForm = {
        semesterId: this.filterSemesterId || (this.semesterList[0] && this.semesterId(this.semesterList[0])) || null,
        title: "",
        fromBank: true
      };
      this.selectedBankQuestionIds = [];
      this.bankQuestions = [];
      this.createDialogVisible = true;
      if (this.schoolId) {
        await this.loadBankForCreate();
      }
      this.$nextTick(() => {
        if (this.$refs.createFormRef) {
          this.$refs.createFormRef.clearValidate();
        }
      });
    },

    async loadBankForCreate() {
      const res = await getHomeVisitQuestionBankAll(this.schoolId);
      const d = res.data;
      if (d.success && d.response) {
        this.bankQuestions = d.response || [];
        this.$nextTick(() => this.applyBankTableSelection());
      }
    },

    applyBankTableSelection() {
      const table = this.$refs.bankTable;
      if (!table || !this.createForm.fromBank) return;
      table.clearSelection();
      this.bankQuestions.forEach((row) => {
        table.toggleRowSelection(row, isHomeVisitBankDefault(row));
      });
    },

    onBankSelectionChange(rows) {
      this.selectedBankQuestionIds = (rows || []).map((r) => r.Id || r.id);
    },

    /** 题库表格 row-key */
    bankTableRowKey(row) {
      if (!row) return "";
      const id = row.Id != null ? row.Id : row.id;
      return id != null ? id : "";
    },

    /** 点击行切换勾选（勾选列内复选框点击由表格默认处理）。最后修改：2026-06-25 */
    onBankTableRowClick(row, column, event) {
      const table = this.$refs.bankTable;
      if (!table || !row) return;
      if (column && column.type === "selection") return;
      const el = event && event.target;
      if (el && el.closest && el.closest(".el-button, button, a, input, textarea, select, label, .el-switch, .el-radio, .el-checkbox, .el-input, .el-link")) {
        return;
      }
      table.toggleRowSelection(row);
    },

    goQuestionBank() {
      this.$router.push("/HomeVisit/QuestionBank");
    },

    async handleCreate() {
      const form = this.$refs.createFormRef;
      if (!form) return;
      const valid = await new Promise((resolve) => {
        form.validate((ok) => resolve(ok));
      });
      if (!valid) return;

      if (!this.schoolId) {
        this.$message.warning("请先在左侧选择学校");
        return;
      }
      if (this.createForm.fromBank && this.selectedBankQuestionIds.length === 0) {
        this.$message.warning("请至少选择一道题库题目，或关闭「从题库选题」");
        return;
      }
      const title = (this.createForm.title || "").trim();
      this.creating = true;
      try {
        let questionnaireId;
        if (this.createForm.fromBank) {
          const res = await createHomeVisitQuestionnaireFromBank({
            SchoolDepartmentId: this.schoolId,
            SemesterId: this.createForm.semesterId,
            Title: title,
            BankQuestionIds: this.selectedBankQuestionIds
          });
          const d = res.data;
          if (!d.success) {
            this.$message.error(d.msg || "创建失败");
            return;
          }
          questionnaireId = d.response;
        } else {
          const res = await saveHomeVisitQuestionnaire({
            SchoolDepartmentId: this.schoolId,
            SemesterId: this.createForm.semesterId,
            Title: title
          });
          const d = res.data;
          if (!d.success) {
            this.$message.error(d.msg || "创建失败");
            return;
          }
          questionnaireId = d.response;
        }
        this.createDialogVisible = false;
        this.$message.success("创建成功");
        await this.loadList();
        await this.openDetailDialog(questionnaireId);
      } finally {
        this.creating = false;
      }
    },

    async handleSaveMeta() {
      if (!this.questionnaire) return;
      this.saving = true;
      try {
        const res = await saveHomeVisitQuestionnaire({
          Id: this.questionnaire.Id,
          SchoolDepartmentId: this.questionnaire.SchoolDepartmentId,
          SemesterId: this.questionnaire.SemesterId,
          Title: this.draftTitle,
          Deadline: this.draftDeadline || null
        });
        const d = res.data;
        if (d.success) {
          this.$message.success("保存成功");
          await this.loadDetail();
        } else {
          this.$message.error(d.msg || "保存失败");
        }
      } finally {
        this.saving = false;
      }
    },

    async handleInitDefault() {
      if (!this.questionnaire) return;
      try {
        await this.$confirm("将覆盖当前问卷全部题目，是否继续？", "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      const res = await initHomeVisitDefaultQuestions({
        QuestionnaireId: this.questionnaire.Id,
        SchoolDepartmentId: this.questionnaire.SchoolDepartmentId,
        SemesterId: this.questionnaire.SemesterId,
        Title: this.draftTitle
      });
      const d = res.data;
      if (d.success) {
        this.$message.success("初始化成功");
        await this.loadDetail();
      } else {
        this.$message.error(d.msg || "初始化失败");
      }
    },

    async handleSetDefault(row) {
      const id = row.Id || row.id;
      const res = await setHomeVisitQuestionnaireDefault({ QuestionnaireId: id });
      const d = res.data;
      if (d.success) {
        this.$message.success(d.msg || "已设为默认");
        if (this.detailDialogVisible) await this.loadDetail();
        await this.loadList();
      } else {
        this.$message.error(d.msg || "操作失败");
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除问卷「${row.Title || ""}」？`, "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      const res = await deleteHomeVisitQuestionnaire(row.Id);
      const d = res.data;
      if (d.success) {
        this.$message.success("删除成功");
        if (this.currentDetailId === Number(row.Id || row.id)) {
          this.detailDialogVisible = false;
        }
        await this.loadList();
      } else {
        this.$message.error(d.msg || "删除失败");
      }
    },

    async handleDeleteQuestion(row) {
      const questionId = this.questionRowId(row);
      if (!this.detailId || !questionId) return;
      const title = row.Title || row.title || "";
      try {
        await this.$confirm(`确认删除第 ${row.SortNo || ""} 题「${title}」？`, "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      this.deletingQuestionId = questionId;
      try {
        const res = await deleteHomeVisitQuestionnaireQuestion(this.detailId, questionId);
        const d = res.data;
        if (d.success) {
          this.$message.success("删除成功");
          await this.loadDetail();
        } else {
          this.$message.error(d.msg || "删除失败");
        }
      } finally {
        this.deletingQuestionId = 0;
      }
    },

    openQuestionEditDialog(row) {
      if (!this.detailId) return;
      if (row) {
        const opts = this.questionOptions(row).map((o) => o.OptionText || o.optionText || "");
        this.questionEditForm = {
          id: this.questionRowId(row),
          sortNo: row.SortNo || row.sortNo || 1,
          sectionTitle: row.SectionTitle || row.sectionTitle || "",
          title: row.Title || row.title || "",
          optionTexts: opts.length >= 2 ? [...opts] : ["", "", "", ""],
          isRequired: row.IsRequired != null ? row.IsRequired : row.isRequired !== false
        };
      } else {
        const questions = (this.questionnaire && this.questionnaire.Questions) || [];
        const nextNo = questions.length ? Math.max(...questions.map((q) => q.SortNo || q.sortNo || 0)) + 1 : 1;
        this.questionEditForm = {
          id: null,
          sortNo: nextNo,
          sectionTitle: "",
          title: "",
          optionTexts: ["", "", "", ""],
          isRequired: true
        };
      }
      this.questionEditDialogVisible = true;
    },

    resetQuestionEditForm() {
      this.questionSaving = false;
    },

    addQuestionOption() {
      if (this.questionEditForm.optionTexts.length < 6) {
        this.questionEditForm.optionTexts.push("");
      }
    },

    removeQuestionOption(idx) {
      if (this.questionEditForm.optionTexts.length > 2) {
        this.questionEditForm.optionTexts.splice(idx, 1);
      }
    },

    async submitQuestionEdit() {
      if (!this.detailId) return;
      if (!this.questionEditForm.title || !this.questionEditForm.title.trim()) {
        this.$message.warning("请填写题干");
        return;
      }
      const optionTexts = this.questionEditForm.optionTexts.map((t) => (t || "").trim()).filter(Boolean);
      if (optionTexts.length < 2) {
        this.$message.warning("至少需要两个选项");
        return;
      }
      this.questionSaving = true;
      try {
        const res = await saveHomeVisitQuestionnaireQuestion({
          QuestionnaireId: this.detailId,
          Id: this.questionEditForm.id || null,
          SortNo: this.questionEditForm.sortNo,
          SectionTitle: this.questionEditForm.sectionTitle,
          Title: this.questionEditForm.title.trim(),
          IsRequired: this.questionEditForm.isRequired,
          OptionTexts: optionTexts
        });
        const d = res.data;
        if (d.success) {
          this.$message.success("保存成功");
          this.questionEditDialogVisible = false;
          await this.loadDetail();
        } else {
          this.$message.error(d.msg || "保存失败");
        }
      } finally {
        this.questionSaving = false;
      }
    },

    openImportDialog() {
      if (!this.questionnaire) return;
      this.resetImportForm();
      this.importFormDialogVisible = true;
    },

    resetImportForm() {
      this.importFileList = [];
      this.importFileRaw = null;
    },

    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1);
      this.importFileRaw = file && file.raw ? file.raw : null;
    },

    onImportFileRemove() {
      this.importFileList = [];
      this.importFileRaw = null;
    },

    handleDownloadTemplate() {
      downloadHomeVisitImportTemplate()
        .then((res) => downloadBlobExcel(res, "家访问卷导入模板"))
        .catch(() => this.$message.error("下载失败"));
    },

    async submitImport() {
      if (!this.importFileRaw || !this.questionnaire) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const form = new FormData();
      form.append("file", this.importFileRaw);
      this.importing = true;
      try {
        const res = await importHomeVisitQuestions(form, this.questionnaire.Id);
        const d = res.data;
        if (d.success && d.response) {
          const r = d.response;
          const successCount = r.SuccessCount != null ? r.SuccessCount : (r.successCount || 0);
          const errors = (r.Errors || r.errors || []).map((x) => ({
            rowNumber: x.RowNumber != null ? x.RowNumber : x.rowNumber,
            message: x.Message != null ? x.Message : x.message
          }));
          this.importErrors = errors;
          this.importResultMsg = errors.length
            ? `成功导入 ${successCount} 题，另有 ${errors.length} 行未导入`
            : `成功导入 ${successCount} 题`;

          this.importFormDialogVisible = false;
          await this.loadDetail();
          this.importDetailQuestions = (this.questionnaire && this.questionnaire.Questions)
            ? [...this.questionnaire.Questions]
            : [];
          this.importResultDialogVisible = true;
          this.$message.success(d.msg || "导入完成");
        } else {
          this.$message.error(d.msg || "导入失败");
        }
      } catch (e) {
        this.$message.error("导入请求失败");
      } finally {
        this.importing = false;
      }
    },

    btnClick(item) {
      if (!item || !item.Func) return;
      if (typeof this[item.Func] === "function") this[item.Func](item);
    }
  }
};
</script>

<style scoped>
.hv-card { min-height: 280px; }
.hv-detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.hv-detail-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 200px;
}
.hv-detail-btn-primary {
  background-color: #2563eb;
  border-color: #2563eb;
}
.hv-detail-btn-primary:hover,
.hv-detail-btn-primary:focus {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}
.hv-detail-btn-plain {
  color: #2563eb;
  border-color: #bfdbfe;
}
.hv-detail-btn-plain:hover,
.hv-detail-btn-plain:focus {
  color: #1d4ed8;
  border-color: #93c5fd;
  background: #eff6ff;
}
.hv-detail-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.hv-detail-section--questions {
  padding-bottom: 12px;
}
.hv-detail-section__label {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
}
.hv-detail-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.hv-detail-section__head .hv-detail-section__label {
  margin-bottom: 4px;
}
.hv-detail-section__head-text {
  flex: 1;
  min-width: 0;
}
.hv-detail-section__desc {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}
.hv-detail-section__tools {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}
.hv-detail-form .el-form-item {
  margin-bottom: 0;
}
.hv-detail-form--meta .hv-detail-meta-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0 12px;
  width: 100%;
}
.hv-detail-form-item--title {
  flex: 1 1 320px;
  min-width: 320px;
  margin-right: 0 !important;
}
.hv-detail-form-item--semester {
  flex: 0 0 auto;
}
.hv-detail-form-item--deadline {
  flex: 0 0 auto;
  margin-right: 0 !important;
}
.hv-detail-form-item--title >>> .el-form-item__label {
  width: 36px !important;
  padding-right: 6px;
}
.hv-detail-form-item--title >>> .el-form-item__content {
  margin-left: 36px !important;
  line-height: 32px;
}
.hv-detail-form-item--semester >>> .el-form-item__label {
  width: 36px !important;
  padding-right: 6px;
}
.hv-detail-form-item--semester >>> .el-form-item__content {
  margin-left: 36px !important;
  line-height: 32px;
}
.hv-detail-form-item--deadline >>> .el-form-item__label {
  width: 64px !important;
  padding-right: 6px;
}
.hv-detail-form-item--deadline >>> .el-form-item__content {
  margin-left: 64px !important;
  line-height: 32px;
}
.hv-detail-title-input {
  width: 100%;
}
.hv-detail-semester-input {
  width: 100px;
}
.hv-detail-deadline-picker {
  width: 186px !important;
}
.hv-detail-form .el-input.is-disabled .el-input__inner {
  color: #64748b;
  background: #f8fafc;
}
.hv-detail-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.hv-detail-table::before {
  display: none;
}
.hv-detail-table >>> .el-table__header th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
}
.hv-detail-table >>> .el-table__body td {
  color: #334155;
}
.hv-detail-table >>> .el-table__body tr:hover > td {
  background-color: #f8fafc !important;
}
.hv-detail-section-tag {
  display: inline-block;
  max-width: 100%;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 18px;
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #dbeafe;
}
.hv-detail-opt-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  margin: 0 6px 4px 0;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 18px;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.hv-detail-opt-chip__key {
  font-weight: 600;
  color: #2563eb;
}
.hv-detail-required {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 18px;
  color: #64748b;
  background: #f1f5f9;
}
.hv-detail-required.is-yes {
  color: #b91c1c;
  background: #fef2f2;
}
.hv-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 48px 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  text-align: center;
}
.hv-detail-empty i {
  font-size: 36px;
  color: #cbd5e1;
}
.hv-detail-empty p {
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}
.hv-detail-empty span {
  font-size: 12px;
  color: #94a3b8;
}
.hv-detail-empty__btn {
  margin-top: 8px;
}
@media (max-width: 768px) {
  .hv-detail-section__head {
    flex-direction: column;
  }
  .hv-detail-section__tools {
    width: 100%;
    justify-content: flex-end;
  }
}
.hv-import-panel { padding: 0 4px; }
.hv-import-step {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}
.hv-import-step:last-child { margin-bottom: 0; }
.hv-step-no {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background: var(--btn-primary, #2563eb);
  color: #fff;
  font-size: 13px;
}
.hv-step-body { flex: 1; min-width: 0; }
.hv-step-title { font-weight: 600; margin-bottom: 6px; color: #303133; }
.hv-step-desc { font-size: 13px; color: #909399; margin-bottom: 10px; }
.hv-upload-block { width: 100%; }
.hv-upload-block >>> .el-upload { width: 100%; }
.hv-upload-block >>> .el-upload-dragger { width: 100%; }
.hv-result-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.hv-result-count { font-size: 13px; color: #606266; }
.hv-result-block { margin-bottom: 16px; }
.hv-result-block:last-child { margin-bottom: 0; }
.hv-result-label {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.hv-empty { flex: 0 0 auto; color: #909399; padding: 24px 0; }
.hv-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.hv-table-wrap >>> .el-table {
  width: 100%;
  height: 100%;
}
.hv-muted { color: #c0c4cc; }
.hv-danger { color: #f56c6c; }
.hv-opt-chip {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
  font-size: 12px;
  color: #606266;
}
</style>

<style>
/* 问卷详情弹窗 */
.el-dialog.hv-detail-dialog {
  overflow: hidden;
}
.el-dialog.hv-detail-dialog .el-dialog__header {
  padding: 14px 20px 10px !important;
  border-bottom: 1px solid #eef2f6 !important;
  background: #f8fafc !important;
}
.el-dialog.hv-detail-dialog .el-dialog__body {
  padding: 14px 20px !important;
  background: #f8fafc;
  max-height: calc(92vh - 120px);
  overflow-y: auto;
}
.el-dialog.hv-detail-dialog .el-dialog__footer {
  padding: 10px 20px 14px !important;
  border-top: 1px solid #eef2f6 !important;
  background: #fff !important;
}
.hv-detail-dialog__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding-right: 28px;
}
.hv-detail-dialog__title-text {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  max-width: 100%;
  word-break: break-word;
}
.hv-detail-dialog__meta {
  font-size: 12px;
  line-height: 20px;
  color: #64748b;
  padding: 2px 10px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.hv-detail-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.el-dialog.hv-detail-dialog .hv-detail-deadline-picker.el-date-editor {
  width: 186px !important;
}
.el-dialog.hv-detail-dialog .hv-detail-deadline-picker .el-input__inner {
  padding-right: 8px;
}
.el-dialog.hv-detail-dialog .hv-detail-title-input {
  width: 100%;
}

/* 新建问卷弹窗（append-to-body；须覆盖 split-layout / home.css .content-az section） */
.el-dialog.hv-create-dialog {
  overflow: visible !important;
}
.el-dialog.hv-create-dialog .hv-create-section {
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}
.el-dialog.hv-create-dialog .el-dialog__header {
  padding: 12px 20px 0 !important;
  border-bottom: none !important;
  background: #f8fafc !important;
}
.el-dialog.hv-create-dialog .el-dialog__title {
  line-height: 1.3;
  padding-right: 32px;
  font-size: 17px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
}
.el-dialog.hv-create-dialog .el-dialog__headerbtn {
  top: 12px;
  right: 16px;
}
.el-dialog.hv-create-dialog .el-dialog__body {
  padding: 0 !important;
  background: #f8fafc;
  max-height: none !important;
  overflow: visible !important;
}
.el-dialog.hv-create-dialog .el-dialog__footer {
  padding: 12px 20px 16px !important;
  border-top: 1px solid #eef2f6 !important;
  background: #fff !important;
}
.hv-create-dialog__title-main {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
}
.hv-create-intro {
  margin: 2px 0 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #64748b;
}
.hv-create-body {
  padding: 0 20px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.hv-create-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 16px 4px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.hv-create-section--basic {
  display: flow-root;
  padding: 10px 16px 10px;
}
.hv-create-section--basic .hv-create-section__label {
  margin-bottom: 8px;
}
.hv-create-section--basic .hv-create-form .el-form-item {
  margin-bottom: 10px;
}
/* 校验错误为 absolute，须在最后一项 content 内预留高度，避免画出卡片底边 */
.hv-create-section--basic .hv-create-form .el-form-item:last-child {
  margin-bottom: 0;
}
.hv-create-section--basic .hv-create-form .el-form-item:last-child .el-form-item__content {
  padding-bottom: 18px;
}
.hv-create-section--bank {
  padding-bottom: 12px;
}
.hv-create-section__label {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}
.hv-create-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.hv-create-section__head .hv-create-section__label {
  margin-bottom: 4px;
}
.hv-create-section__head-text {
  flex: 1;
  min-width: 0;
}
.hv-create-section__desc {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: #64748b;
}
.hv-create-section__head .el-switch {
  flex-shrink: 0;
  margin-top: 2px;
}
.hv-create-section__head .el-switch__label {
  font-size: 12px;
  color: #64748b;
}
.hv-create-section__head .el-switch__label.is-active {
  color: #2563eb;
}
.hv-create-alert {
  margin: 0;
  border-radius: 8px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
}
.hv-create-alert .el-alert__title {
  font-size: 13px;
  line-height: 1.55;
  color: #475569;
}
.hv-bank-picker {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.hv-bank-picker__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}
.hv-bank-picker__stats {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.hv-stat-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 20px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.hv-stat-chip--active {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #bfdbfe;
  font-weight: 600;
}
.hv-bank-manage-btn {
  padding: 4px 6px;
  font-size: 13px;
  color: #2563eb;
  transition: color 0.2s ease;
}
.hv-bank-manage-btn:hover {
  color: #1d4ed8;
}
.el-dialog.hv-create-dialog .hv-bank-table {
  border: none;
}
.el-dialog.hv-create-dialog .hv-bank-table::before {
  display: none;
}
.el-dialog.hv-create-dialog .hv-bank-table .el-table__header th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
}
.el-dialog.hv-create-dialog .hv-bank-table .el-table__body td {
  color: #334155;
}
.el-dialog.hv-create-dialog .hv-bank-table--clickable .el-table__body tr {
  cursor: pointer;
}
.el-dialog.hv-create-dialog .hv-bank-table--clickable .el-table__body tr:hover > td {
  background-color: #f1f5f9 !important;
}
.hv-create-footer .hv-create-submit {
  min-width: 96px;
  background-color: #2563eb;
  border-color: #2563eb;
}
.hv-create-footer .hv-create-submit:hover,
.hv-create-footer .hv-create-submit:focus {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}
@media (max-width: 768px) {
  .hv-create-section__head {
    flex-direction: column;
    align-items: stretch;
  }
  .hv-create-section__head .el-switch {
    align-self: flex-start;
  }
}

/* 问卷题目编辑弹窗（与默认题库共用样式类） */
.hv-edit-dialog .el-dialog__body {
  padding: 16px 24px 8px;
}
.hv-edit-dialog .hv-edit-form .el-form-item {
  margin-bottom: 16px;
}
.hv-edit-dialog .hv-edit-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}
.hv-edit-dialog .hv-options-item .el-form-item__content {
  line-height: normal;
}
.hv-edit-dialog .hv-options-panel {
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-sizing: border-box;
}
.hv-edit-dialog .hv-opt-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.hv-edit-dialog .hv-opt-row:last-of-type {
  margin-bottom: 0;
}
.hv-edit-dialog .hv-opt-badge {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 6px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.hv-edit-dialog .hv-opt-input {
  flex: 1;
  min-width: 0;
}
.hv-edit-dialog .hv-opt-del {
  flex-shrink: 0;
  width: 32px;
  padding: 0;
  font-size: 16px;
  color: #c0c4cc;
}
.hv-edit-dialog .hv-opt-del:hover {
  color: #f56c6c;
}
.hv-edit-dialog .hv-opt-del-placeholder {
  flex-shrink: 0;
  width: 32px;
}
.hv-edit-dialog .hv-opt-add {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 8px 0;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  color: #2563eb;
  text-align: center;
}
.hv-edit-dialog .hv-opt-add:hover {
  border-color: #2563eb;
  background: #eff6ff;
}
.hv-edit-dialog .hv-edit-footer {
  padding-top: 4px;
}
</style>
